// extracted by mini-css-extract-plugin
export default {"card":"RegistrationTypeCard_card__iF8ct","selected":"RegistrationTypeCard_selected__0Mc8T"};